import { PatientsState } from '../../model/patient/PatientsState';
import {
  CLEAR_SELECTED_PATIENT_TEST_DETAIL,
  FETCH_PATIENTS_SUCCESS,
  FETCH_PATIENT_DETAIL,
  FETCH_PATIENT_DETAIL_FAILURE,
  FETCH_PATIENT_DETAIL_SUCCESS,
  FETCH_PATIENT_TESTS_SUCCESS,
  FETCH_PATIENT_TEST_DETAIL_SUCCESS,
  FETCH_PATIENT_TEST_TABLE_DATA,
  FETCH_PATIENT_TEST_TABLE_DATA_FAILURE,
  FETCH_PATIENT_TEST_TABLE_DATA_SUCCESS,
  FETCH_PENDING_PATIENTS_SUCCESS,
  SET_SELECTED_TEST_DATE,
  TOGGLE_COMPLIANCE_AUTOTRACKING_SUCCESS,
} from '../constants';
import { initialState } from '../system/SystemState';
import { PatientActionTypes } from '../types/patientActionTypes';

export default function patientReducer(
  state = initialState.patients,
  action: PatientActionTypes
): PatientsState {
  switch (action.type) {
    case FETCH_PATIENTS_SUCCESS:
      return {
        ...state,
        patients: action.payload,
      };
    case FETCH_PENDING_PATIENTS_SUCCESS:
      return {
        ...state,
        pendingPatients: action.payload,
      };
    case FETCH_PATIENT_TESTS_SUCCESS:
      return {
        ...state,
        patientTests: action.payload,
      };
    case FETCH_PATIENT_TEST_DETAIL_SUCCESS:
      return {
        ...state,
        selectedTest: {
          ...state.selectedTest,
          detail: action.payload,
        },
      };
    case FETCH_PATIENT_DETAIL:
      return {
        ...state,
        selectedPatient: null,
        patientDetailError: null,
      };
    case FETCH_PATIENT_DETAIL_SUCCESS:
      return {
        ...state,
        selectedPatient: action.payload,
        patientDetailError: null,
      };
    case FETCH_PATIENT_DETAIL_FAILURE:
      return {
        ...state,
        selectedPatient: null,
        patientDetailError: action.payload,
      };

    case TOGGLE_COMPLIANCE_AUTOTRACKING_SUCCESS:
      return {
        ...state,
        selectedPatient: state.selectedPatient
          ? {
              ...state.selectedPatient,
              isComplianceEnabled: action.payload,
            }
          : null,
      };

    case FETCH_PATIENT_TEST_TABLE_DATA:
      return {
        ...state,
        selectedTest: {
          ...state.selectedTest,
          tableData: {
            ...state.selectedTest.tableData,
          },
          isLoading: true,
        },
      };
    case FETCH_PATIENT_TEST_TABLE_DATA_SUCCESS:
      return {
        ...state,
        selectedTest: {
          ...state.selectedTest,
          tableData: {
            ...state.selectedTest.tableData,
            [action.payload.key]: action.payload.data,
          },
          isLoading: false,
        },
      };
    case FETCH_PATIENT_TEST_TABLE_DATA_FAILURE:
      return {
        ...state,
        selectedTest: {
          ...state.selectedTest,
          isLoading: false,
        },
      };

    case SET_SELECTED_TEST_DATE:
      return {
        ...state,
        selectedTest: {
          ...state.selectedTest,
          dateTime: action.payload,
        },
      };

    case CLEAR_SELECTED_PATIENT_TEST_DETAIL:
      return {
        ...state,
        patientTests: [],
        selectedTest: {
          dateTime: '',
          detail: null,
          tableData: null,
          isLoading: false,
        },
      };
    default:
      return state;
  }
}
